import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, Grid, Box, Button,
  useMediaQuery
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useTheme } from '@mui/material/styles';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';

export default function MedicalHistoryReportDataGrid({ data = null }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  // ✅ CSV Export Handler
  const handleDownloadCSV = () => {
    if (!data || data.length === 0) return;

    const headers = [
      "Case Number",
      "Date",
      "Time",
      "Attending Doctor",
      "Pet Owner",
      "Pet",
      "Procedure"
    ];

    const rows = data.map((row) => [
      row.caseNumber,
      formatToLocalDateTime(row.datetime).split(" ")[0],
      formatToLocalDateTime(row.datetime).split(" ")[1],
      row.attendingDoctor,
      row.owner,
      row.petName,
      row.procedure
    ]);

    const csvContent =
      [headers, ...rows]
        .map((e) => e.join(","))
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "medical_history_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box>

      {/* ✅ Download Button */}
      <Box sx={{ mb: 2 }}>
        <Button variant="outlined" fullWidth={!isDesktop} color="primary" onClick={handleDownloadCSV}>
          <DownloadIcon /> Download CSV
        </Button>
      </Box>

      {/* ✅ Table with Sticky Header */}
      <TableContainer
        component={Paper}
        sx={{
          border: '1px solid lightgray',
          flex: 1,              // fill remaining space
          maxHeight: 450,    // respect Dialog’s maxHeight
          overflow: 'auto'      // scroll inside modal
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {[
                "Case Number",
                "Date",
                "Time",
                "Attending Doctor",
                "Pet Owner",
                "Pet",
                "Procedure"
              ].map((header, idx) => (
                <TableCell
                  key={idx}
                  sx={{
                    verticalAlign: 'top',
                    lineHeight: 1,
                    py: 2,
                    backgroundColor: 'background.paper',
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap'
                  }}
                  align={['Case Number'].includes(header) ? 'left' : 'center'}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5 }} align='left'>{row.caseNumber}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5, whiteSpace: 'nowrap' }} align='center'>{formatToLocalDateTime(row.datetime).split(" ")[0]}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5, whiteSpace: 'nowrap' }} align='center'>{formatToLocalDateTime(row.datetime).split(" ")[1]}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5 }} align='center'>{row.attendingDoctor}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5 }} align='center'>{row.owner}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5 }} align='center'>{row.petName}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', lineHeight: 1, py: 0.5 }} align='center'>{row.procedure}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
